<template>
    <Refinement class="refinement-form desktop"/>
</template>

<script>
import Refinement from './components/Refinement.vue';

export default {
  name: 'app',
  components: {
    Refinement,
  },
};
</script>

